import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PlatformService } from '@core/services/platform.service';

import { ZendeskService } from '../zendesk.service';
import { TranslateSafePipe } from '../../../../@shared/translate-safe/translate-safe.pipe';
import { LoadingDotsComponent } from '../../../../@shared/loading-dots/loading-dots.component';
import { SvgIconComponent } from '../../../../@shared/svg-icon/svg-icon.component';
import { ZendeskDirective } from '../zendesk.directive';
import { NgIf, NgClass, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-zendesk-button',
    templateUrl: './zendesk-button.component.html',
    styleUrls: ['./zendesk-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, ZendeskDirective, NgClass, SvgIconComponent, LoadingDotsComponent, AsyncPipe, TranslateSafePipe]
})
export class ZendeskButtonComponent {
    constructor(public readonly zendeskService: ZendeskService, public readonly platformService: PlatformService) {}
}
